import React, { useEffect, useState } from "react";
import "../assets/style/Applicationstatus.css";
import { useDispatch, useSelector } from "react-redux";
import { updateData } from "../redux/roundtoSlice";
import { useNavigate } from "react-router-dom";
import arrowRight from "../assets/images/arrow-right.svg";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import closeIcon from "../assets/images/closeIcon.svg";
import ApiConfig from "../api/ApiConfig";
import { PostCallWithErrorResponse, postWithAuthCall } from "../api/ApiServices";
import VerifiedUserWhite from "../assets/images/VerifiedUserWhite.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import { Tooltip } from "react-tooltip";
import { getBrowser } from "../constant/getBrowser";
import { getOS } from "../constant/getOS";

export default function LywoApplicationStatus() {

  const state = useSelector(state => state?.roundData)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isDataLoad, setIsDataLoad] = useState(false)

  const [isSavedQuiz, setIsSavedQuiz] = useState(false)

  const [customQuizLink, setCustomQuizLink] = useState('')

  const [showRedirectModal, setShowRedirectModal] = useState(false)

  const [isMobileView, setIsMobileView] = useState(null);

  const isMobile = () => {
    return window.innerWidth <= 768
      ? setIsMobileView(true)
      : setIsMobileView(false);
  };

  useEffect(() => {

    isMobile();
    window.addEventListener("resize", isMobile);
    return () => {

      window.removeEventListener("resize", isMobile);
    };


  }, []);



  useEffect(() => {

    isMobile();
    return () => {

      window.removeEventListener("resize", isMobile);
    };


  }, []);
  const getAssementDetails = async (code = '', userId = '') => {

    // if (!state.isSaveQuiz) return

    setIsDataLoad(false)

    PostCallWithErrorResponse(ApiConfig.GET_QUIZE_QUESTIONS, {
      jobcode: code ? code : state?.code,
      userId: userId ? userId : state.userId,
    }).then((res) => {
      if (res?.json?.succeded) {
        setIsSavedQuiz(res?.json?.response?.isSavedQuiz)
        setCustomQuizLink(res?.json?.response?.link)
        dispatch(
          updateData({
            field: "questions",
            value: res?.json?.response?.questions,
          })
        );
        dispatch(
          updateData({
            field: "duration",
            value: res?.json?.response?.duration,
          })
        );
        dispatch(
          updateData({ field: "quizId", value: res?.json?.response?.quizId })
        );
        setIsDataLoad(true)
      }

    })

  }

  useEffect(() => {
    // Push current state to history stack
    window.history.pushState(null, document.title, window.location.href);

    const handleBackButton = (event) => {
      window.history.pushState(null, document.title, window.location.href);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  useEffect(() => {
    if (state.step == 2) {
      dispatch(updateData({ field: 'isQuiz', value: true }))
      getAssementDetails()
    }

  }, [])
  const updateStartQuiz = async () => {

    let payload = {
      view: isMobileView ? "mobile" : "desktop",
      browser: getBrowser(),
      os: getOS(),
    }

    let res = PostCallWithErrorResponse(ApiConfig.UPDATE_QUIZ_START + `userid=${state.userId}&code=${state.code}`, payload)
    return res
  }

  const handleStartPersonalityTest = async (step) => {


    if (step === 2) {
      navigate('/CompanyName')
    }

    if (step === 3) {
      if (!isDataLoad) return

      let res = await updateStartQuiz()

      if (isSavedQuiz) {
        navigate('/Questionanswer1')
      } else {
        setShowRedirectModal(true)
      }

    }

  };

  const editProfile = () => {

    dispatch(updateData({ field: 'isEditDetails', value: true }))
    navigate("/JobApplicationProcess", { state: { fromOtherPage: true } })


  }

  const handleStartMcqQuiz = () => {

  };

  return (
    <div className="status-main1">
      <div className="status-container">
        <p className="greeting">Dear {state.userName || "Aplicant "} </p>
        <p className="thank-you">Thank you !</p>
        <p className="step-status">
          Application Status - {state?.step} of 3 Steps Complete
        </p>

        <div className="step-circles">
          <div className={`step ${state?.step >= 1 ? "active" : ""}`}>
            <div className="circle">1</div>
            <p>Basic Info</p>
          </div>
          <div className={`step ${state?.step >= 2 ? "active" : ""}`}>
            <div className="circle">2</div>
            <p>Personality Test</p>
          </div>
          <div className={`step ${state?.step >= 3 ? "active" : ""}`}>
            <div className="circle">3</div>
            <p>Short Quiz</p>
          </div>
        </div>

        {state?.step === 1 && (
          <>
            <p className="desc">
              Your Resume alone doesn’t give the full picture !
            </p>
            <button
              className="personality-btn"
              onClick={() => handleStartPersonalityTest(2)}
            >
              Start Personality Test <span className="arrow">▶</span>
            </button>
            <p className="test-time">Test Time: Approx. 8 minutes</p>
            <p className="know-you">Allow us to know you better !</p>
            <p className="note">
              Stressful / Short Interviews don't give us the opportunity to know
              you best.
            </p>
          </>
        )}

        {state?.step === 2 && (
          <>
            <p className="desc">
              Your short Personality Report has been mailed to you
            </p>
            <button className="personality-btn" onClick={() => handleStartPersonalityTest(3)}>
              Start MCQ Quiz <span className="arrow">▶</span>
            </button>
            {/* <p className="test-time">Test Time: {state?.duration} minutes</p> */}
            <p className="know-you">Demonstrate your basic skills.</p>
            <p className="note">Avoid uncomfortable Pre Screening calls !</p>
          </>
          // <>
          //   <p className="desc">Your Personality has been mailed to you also</p>
          //   <button className="personality-btn exit-btn">
          //     Exit <span className="arrow" data-label="exit-icon"></span>
          //   </button>
          //   <p className="thank-you">Your Quiz is Not Ready Yet !</p>
          //   <p className="note">
          //     You will receive an email once your Quiz is ready.
          //   </p>
          // </>
        )}

        {state?.step === 3 && (
          <>
            <p className="desc">We have your Complete Application</p>
            {/* <button className="personality-btn exit-btn"
              onClick={() => navigate('/LoginWithCode')}
            >
              Exit{" "}
              <span
                className="arrow"
                data-label="exit-icon"
                aria-hidden="true"
              ></span>
            </button> */}
            <p className="thank-you">Thank you for your Time.</p>
            <p className="note" style={{ marginTop: '-4px' }}>
              We will reach out to you soon.
              <br />
              <span style={{ fontSize: "13px", color: "#667085" }}>
                If you want to update your profile , please use the link below
              </span>
            </p>
          </>
        )}
      </div>
      {showRedirectModal && (
        <div className="mcq-sbmt-modal-overlay1">

          <div className="mcq-sbmt-modal-content1 center-content">
            <div
              className="modal-close1"
              onClick={() => setShowRedirectModal(false)}
            >
              <img src={closeIcon} alt="Close" />
            </div>

            <h4 className="redirect-title1">
              You Are Leaving{" "}

            </h4>
            <p className="redirect-subtitle1">
              MCQ will be conducted via Google Forms
            </p>

            <div className="warning-msg1">
              {/* <img src={Frame1} alt="warn" /> */}
              <span className="">
                Provide the same Email on the form as you have used in this application !
              </span>

            </div>
            <div className="center-btn-wrapper mb-3 mt-3">
              <div
                className="btnLywo12"
                onClick={() => {
                  // window.open(rounddata?.externalQuizLink, "_self");
                  window.open(customQuizLink, "self");

                  setShowRedirectModal(true);
                }}
              >
                <p>Launch The test</p>
                <img src={arrowRight} className="mobIcon" alt="start" />
              </div>
            </div>

            {/* <button className="launch-btn1" onClick={() => window.open("https://docs.google.com/forms/your-form-link", "_blank")}>
           
          </button> */}

            <p className="quiz-link-note1" style={{ marginBottom: "0px" }}>
              If you’re not redirected after clicking on the button, click the link below:
            </p>
            <a className="quiz-link link-qizzz" href={customQuizLink} target="_blank" rel="noreferrer">
              {customQuizLink}
            </a>
          </div>
        </div>
      )}
      <div className="dsktp-footer">
        <div className="dsktp-footer-right">
          {/* <div className='lang-dsktp'>
                           <img src={languageIcon} className="mobIcon" alt="Select language" />
                           <p>Behavior test Language</p>
                           <div className='langbox-dsktp' onClick={() => setShowLanguagePopup(true)}>
                               <p>English</p>
                               <img src={arrowUp} className="mobIcon" alt="Select language" />
                           </div>
                       </div> */}

          <button
            className="comp-savebtn"
            onClick={editProfile}
            style={{ width: "120px", padding: "8px 14px", height: "40px" }}

            data-tooltip-id="edit-btn"
            data-tooltip-place="top-start"
          >
            Edit Profile

            {/* <Tooltip style={{ width: "220px" }} id="edit-btn">You don’t have permission to Edit Profile from here</Tooltip> */}
          </button>
        </div>
        <div className="dsktp-footer-left">
          <div className="dsktp-footerjob-info">
            <div className="v-u-jobcode">
              <h6 style={{ display: "flex", justifyContent: "end" }}>
                {state.code}
              </h6>
              <p>
                This application Process is Managed by <span>LYWO</span>
              </p>
            </div>
            <div className="v-u-bg">
              <img src={VerifiedUserWhite} className="vu-icon" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-icons-mcq">

        <div className="mobile-icon-txt" onClick={editProfile}>
          <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
          <p>Edit Profile</p>
        </div>
      </div>
    </div>
  );
}
